import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { selectContext } from "../store/contextSlice";
import { request } from "../services/cpln";

export function useGvcContextNavigation(kind: "workload" | "identity" | "volumeset") {
  const navigate = useNavigate();
  const params = useParams();
  const context = useAppSelector(selectContext);

  const orgName = params.org;
  const gvcName = params.gvc;
  const itemName = params[kind];

  React.useEffect(() => {
    if (!context.gvc || !context.org) return;
    if (!orgName || !gvcName || !itemName) return;
    if (context.gvc === gvcName) return;
    if (context.org !== orgName) return;

    let cancelled = false;

    (async () => {
      try {
        await request({ url: `/org/${orgName}/gvc/${context.gvc}/${kind}/${itemName}` });
        if (cancelled) return;
        const currentPath = window.location.pathname;
        const newPath = currentPath.replace(`/gvc/${gvcName}/`, `/gvc/${context.gvc}/`);
        navigate(newPath);
      } catch (e) {
        // Item doesn't exist under new GVC — stay on current page
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [context.gvc]);
}
